export default __webpack_public_path__ + "assets/ttf.28668a6c059779e01fe7dc66dd70ef40.png";